export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_SEASON_CLASS_SUCCESS = 'UPDATE_SEASON_CLASS_SUCCESS';
export const PERSIST_APPLICATION = 'PERSIST_APPLICATION';
export const PERSIST_SEASON_CLASS = 'PERSIST_SEASON_CLASS';
export const PERSIST_UNSUPPORTED_SCHOOLS_INTEREST = 'PERSIST_UNSUPPORTED_SCHOOLS_INTEREST';
export const PERSIST_ALL = 'PERSIST_ALL';
export const NOTIFY_ERROR = 'NOTIFY_ERROR';
export const NOTIFY_API_ERROR = 'NOTIFY_API_ERROR';
export const CLEAR_API_ERRORS = 'CLEAR_API_ERRORS';
export const DISMISS_API_ERROR = 'DISMISS_API_ERROR';
export const ADD_RESIDENCE_HISTORY = 'ADD_RESIDENCE_HISTORY';
export const UPDATE_RESIDENCE_HISTORY = 'UPDATE_RESIDENCE_HISTORY';
export const REMOVE_RESIDENCE_HISTORY = 'REMOVE_RESIDENCE_HISTORY';
export const RESET_RESIDENCE_HISTORY = 'RESET_RESIDENCE_HISTORY';
export const PERSIST_RESIDENCE_HISTORY = 'PERSIST_RESIDENCE_HISTORY';
export const RESET_COURSES = 'RESET_COURSES';
export const ADD_PAGE_DATA = 'ADD_PAGE_DATA';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const QUERY_ELIGIBILITY_REQUEST = 'QUERY_ELIGIBILITY_REQUEST';
export const QUERY_ELIGIBILITY_SUCCESS = 'QUERY_ELIGIBILITY_SUCCESS';
export const QUERY_ELIGIBILITY_ERROR = 'QUERY_ELIGIBILITY_ERROR';
export const QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_REQUEST =
  'QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_REQUEST';
export const QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_SUCCESS =
  'QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_SUCCESS';
export const QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_ERROR =
  'QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_ERROR';
export const QUERY_MIN_LOAN_AMOUNT_REQUEST = 'QUERY_MIN_LOAN_AMOUNT_REQUEST';
export const QUERY_MIN_LOAN_AMOUNT_SUCCESS = 'QUERY_MIN_LOAN_AMOUNT_SUCCESS';
export const WIZARD_NAVIGATE = 'WIZARD_NAVIGATE';
export const WIZARD_FORWARD = 'WIZARD_FORWARD';
export const WIZARD_BACK = 'WIZARD_BACK';
export const WIZARD_PATHS = 'WIZARD_PATHS';
export const WIZARD_UPDATE_FORWARD = 'WIZARD_UPDATE_FORWARD';
export const WIZARD_UPDATE_BACK = 'WIZARD_UPDATE_BACK';
export const WIZARD_UPDATE_PATH = 'WIZARD_UPDATE_PATH';
export const NAVIGATION_CHANGE = 'NAVIGATION_CHANGE';
export const DO_SIGN_IN = 'DO_SIGN_IN';
export const SIGNING_IN = 'SIGNING_IN';
export const SIGN_IN = 'SIGN_IN';
export const TOKEN_RENEW = 'TOKEN_RENEW';
export const TOKEN_RENEW_FAILED = 'TOKEN_RENEW_FAILED';
export const API_AUTHENTICATION_ERROR = 'API_AUTHENTICATION_ERROR';
export const LOG_OUT = 'LOG_OUT';
export const ADD_LIABILITY = 'ADD_LIABILITY';
export const REMOVE_LIABILITY = 'REMOVE_LIABILITY';
export const PERSIST_LIABILITIES = 'PERSIST_LIABILITIES';
export const APPLICATION_SUBMIT = 'APPLICATION_SUBMIT';
export const APPLICATION_SUBMIT_SUCCESS = 'APPLICATION_SUBMIT_SUCCESS';
export const FETCH_CAP_ON_LOAN = 'FETCH_CAP_ON_LOAN';
export const FETCH_CAP_ON_LOAN_SUCCESS = 'FETCH_CAP_ON_LOAN_SUCCESS';
export const BUILDER_SEND = 'BUILDER_SEND';
export const BUILDER_FETCH = 'BUILDER_FETCH';
export const BUILDER_CONTINUE_LATEST = 'BUILDER_CONTINUE_LATEST';
export const FETCH_BUILDER_SUCCESS = 'FETCH_BUILDER_SUCCESS';
export const APPLICATION_MAP_SERVER_TO_UI = 'APPLICATION_MAP_SERVER_TO_UI';
export const BUILDER_MERGE_INTO_UI = 'BUILDER_MERGE_INTO_UI';
export const ZENDESK_LOADED = 'ZENDESK_LOADED';
export const ZENDESK_LOGIN_USER = 'ZENDESK_LOGIN_USER';
export const FETCH_EMPLOYERS_REQUEST = 'FETCH_EMPLOYERS_REQUEST';
export const FETCH_EMPLOYERS_SUCCESS = 'FETCH_EMPLOYERS_SUCCESS';
export const RESTART_IN_PLATFORM = 'RESTART_IN_PLATFORM';
export const TRACK_IN_HEAP = 'TRACK_IN_HEAP';
export const UNRECOVERABLE_ERROR = 'UNRECOVERABLE_ERROR';
export const RECOVERABLE_ERROR = 'RECOVERABLE_ERROR';
export const INELIGIBLE_LOAN_ERROR = 'INELIGIBLE_LOAN_ERROR';
export const CLEAR_STATE = 'CLEAR_STATE';
export const FETCH_PROVISIONAL_OFFER_REQUEST = 'FETCH_PROVISIONAL_OFFER_REQUEST';
export const FETCH_PROVISIONAL_OFFER_SUCCESS = 'FETCH_PROVISIONAL_OFFER_SUCCESS';
export const FETCH_PROVISIONAL_OFFER_FAILURE = 'FETCH_PROVISIONAL_OFFER_FAILURE';
export const RESET_PROVISIONAL_OFFER_FAILURE = 'RESET_PROVISIONAL_OFFER_FAILURE';
